/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationUpdatePathParams,
	OrganisationUpdateRequest,
	OrganisationUpdateResponse,
} from '../types/OrganisationUpdate'

/**
 * PUT /organisations/:organisation
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::update
 */
export async function organisationUpdate(
	organisation: OrganisationUpdatePathParams['organisation'],
	data: OrganisationUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationUpdateResponse>> {
	return axiosInstance.put(`/organisations/${organisation}`, data, config)
}
